import React from 'react';
import { IconSparkles } from '@tabler/icons-react';
import { Skeleton } from '../../ui/Skeleton';
import { CollectionPresence } from '../../ui/CollectionPresence';

/** Props for {@link AskHollieCard}. */
export interface AskHollieCardProps {
  /** Suggested questions built from the campaign's own questions. */
  suggestions?: string[];
  onAsk: (question: string) => void;
  /** Shown beside the heading, such as the button that opens the Ask hollie chat. */
  action?: React.ReactNode;
}

/** The way into detail: a sparkle card whose suggestions ask hollie directly. */
export const AskHollieCard: React.FC<AskHollieCardProps> = ({ suggestions, onAsk, action }) => (
  <section className="flex flex-col gap-4 rounded-[20px] border border-border/50 bg-surface px-6 py-5 light:border-transparent">
    <header className="flex items-center justify-between gap-3">
      <h2 className="flex items-center gap-2 text-base font-semibold text-foreground">
        <IconSparkles aria-hidden="true" className="h-5 w-5 text-accent-soft" />
        Ask hollie
      </h2>
      {action}
    </header>
    {(!suggestions || suggestions.length > 0) && <CollectionPresence contentKey={suggestions ? 'ready' : 'loading'}><div className="flex flex-wrap gap-2">
      {(suggestions ?? [undefined, undefined]).map((suggestion, index) => (
        <button key={index} type="button" disabled={suggestion === undefined} aria-hidden={suggestion === undefined} onClick={() => suggestion !== undefined && onAsk(suggestion)} data-tip={suggestion} data-tip-truncated
          className="max-w-full truncate rounded-full bg-wash-accent px-4 py-2 text-sm text-foreground transition-colors hover:bg-surface-hover focus-visible:outline-2 focus-visible:outline-ring light:bg-surface-raised">
          {suggestion ?? <Skeleton width="18ch" inline />}
        </button>
      ))}
    </div></CollectionPresence>}
  </section>
);
